import { enumeration } from '@dazn/peng-html5-tools-utils';
var SolutionEventType = enumeration([
    'ACTIVE_AUDIO_TRACK_CHANGE',
    'ACTIVE_TEXT_TRACK_CHANGE',
    'ADAPTATION',
    /**
     * To be dispatched by compatible solutions when the core requests that the solution enable
     * an adaptive presentation delay, but the solution is missing the capabilities or necessary
     * data to do so (e.g. a synchronised clock).
     */
    'ADAPTIVE_PRESENTATION_DELAY_REJECTED',
    'AUDIO_TRACKS_CHANGE',
    'AUTOPLAY_REJECTION',
    'BANDWIDTH_ESTIMATION_CHANGE',
    'BUFFER',
    'BUFFER_DURATION_CHANGE',
    'DYNAMIC_RANGE_IDENTIFIED',
    'CUE_CHANGE',
    'DESTROYED',
    'DROPPED_FRAMES_CHANGE',
    'DRM_KEY_SESSION_STATE_CHANGE',
    'ENDED',
    'HTTP_REQUEST_STATE_CHANGE',
    'MANIFEST_PARSED',
    'MESSAGE',
    'METRICS',
    'PAUSE',
    'PERIOD_CHANGE',
    'PLAY',
    'PLAYBACK_RATE_CHANGE',
    /**
     * To be dispatched by compatible solutions whenever the player has achieved the desired
     * presentation delay (default or custom)
     */
    'PRESENTATION_DELAY_ACHIEVED',
    /**
     * To be dispatched by compatible solutions whenever the player is working to achieve the
     * desired presentation delay (default or custom)
     */
    'PRESENTATION_DELAY_PENDING',
    'TEXT_TRACKS_CHANGE',
    'TIME_UPDATE',
    'TIMED_METADATA',
    'TIMELINE_REGION_ADDED',
    'TIMELINE_REGION_ENTER',
    'TIMELINE_REGION_EXIT',
    'SUPPORTED_CODECS_IDENTIFIED',
]);
export { SolutionEventType };
//# sourceMappingURL=SolutionEventType.js.map